import { FormControl, FormLabel, Grid, Slider, Typography, TextField, IconButton } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';
import { useEffect, useState } from 'react';

const CantidadEstudiantes = () => {
    const { promptData, setPromptData } = useActividadesContext();
     const [cantidad, setCantidad] = useState(promptData.cantidad_estudiantes || 1);
       
         useEffect(() => {
           setPromptData((prevData) => ({
             ...prevData,
             cantidad_estudiantes: cantidad,
           }));
         }, [cantidad, setPromptData]);
       
         const handleSliderChange = (event, newValue) => {
           setCantidad(newValue);
         };
       
         const handleInputChange = (event) => {
           const newValue = event.target.value === '' ? '' : Number(event.target.value);
           setCantidad(newValue);
         };
       
         const handleIncrement = () => {
           setCantidad((prev) => Math.min(prev + 1, 100));
         };
       
         const handleDecrement = () => {
           setCantidad((prev) => Math.max(prev - 1, 1));
         };

    return (
        <Grid sx={{ mb: 3 }}>
            <FormControl component="fieldset">
                <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                    Cantidad de estudiantes *
                </Typography>
                <FormLabel component="p" sx={{ fontFamily: 'montserrat', fontSize: '0.85rem', mt: 0.2 }}>
                    Selecciona la cantidad de estudiantes a participar
                </FormLabel>
                <Grid container alignItems="center" justifyContent="space-between" spacing={2} width={600}>
                    {/* Slider en la parte izquierda */}
                    <Grid item xs={8}>
                        <Slider
                            value={typeof cantidad === 'number' ? cantidad : 0}
                            onChange={handleSliderChange}
                            step={1}
                            min={1}
                            max={100}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(value) => `${value} estudiantes`}
                            aria-labelledby="cantidad_estudiantes-slider"
                            sx={{
                                color: '#336B87',
                                '& .MuiSlider-markLabel': {
                                    color: '#336B87',
                                    fontFamily: 'montserrat',
                                },
                                '& .MuiSlider-valueLabel': {
                                    backgroundColor: '#F9DA96',
                                    color: '#209099',
                                    fontFamily: 'montserrat'
                                },
                            }}
                        />
                    </Grid>
                    {/* Contador en la parte derecha */}
                    <Grid item xs={4} container spacing={1}>
                        <Grid item>
                            <IconButton onClick={handleDecrement} disabled={cantidad <= 1}>
                                <Remove />
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <TextField
                                variant="standard"
                                value={cantidad}
                                onChange={handleInputChange}
                                inputProps={{
                                    step: 1,
                                    min: 4,
                                    max: 99,
                                    type: 'text',
                                    fontFamily: 'montserrat',
                                    color: '#336B87',
                                    sx: { fontFamily: 'montserrat', color: '#336B87', textAlign: 'center' }
                                }}
                                sx={{ width: 40, textAlign: 'center', fontFamily: 'montserrat', color: '#336B87' }}
                            />
                        </Grid>

                        <Grid item>
                            <IconButton onClick={handleIncrement} disabled={cantidad >= 100}>
                                <Add />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </FormControl>
        </Grid>
    );
};

export default CantidadEstudiantes;
